
import { sleep } from '@/canv/utils.js'

//Progress class
export class ProgressBar {
  constructor() {

  }

  async show() {

    let template = `
      <div class="progressBarLogo">
        <svg width="90" height="90" viewBox="0 0 90 90" fill="none" xmlns="http://www.w3.org/2000/svg">
        <mask id="mask0_463_42" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="90" height="90">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M27.885 0H62.1225C71.82 0 75.33 1.01258 78.8774 2.90274C82.4248 4.8004 85.2002 7.58312 87.0978 11.1234C88.9948 14.6712 90 18.1815 90 27.8799V62.1201C90 71.8186 88.9878 75.3286 87.0978 78.8767C85.2002 82.4241 82.4178 85.1995 78.8774 87.0972C75.33 88.9948 71.82 90 62.1225 90H27.885C18.1875 90 14.6775 88.9872 11.13 87.0972C7.5825 85.1995 4.8075 82.4172 2.91 78.8767C1.0125 75.3362 0 71.8186 0 62.1201V27.8873C0 18.189 1.0125 14.6787 2.9025 11.1309C4.8 7.58312 7.5825 4.8004 11.13 2.90274C14.67 1.01258 18.1875 0 27.885 0Z" fill="black"/>
        </mask>
        <g mask="url(#mask0_463_42)">
        <path d="M90 0H0V90H90V0Z" fill="#FF0032"/>
        </g>
        <mask id="mask1_463_42" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="20" y="20" width="50" height="50">
        <path d="M69.168 20.8311H20.8311V69.168H69.168V20.8311Z" fill="white"/>
        </mask>
        <g mask="url(#mask1_463_42)">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M20.8311 52.632V36.0957H33.5655V52.632C33.5655 54.7404 35.2682 56.4481 37.3706 56.4481H53.9037V69.1684H37.323C28.2161 69.1684 20.8342 61.7652 20.8342 52.632H20.8311Z" fill="white"/>
        <path d="M45.1937 22.8167L38.723 48.0514C38.1992 50.038 39.9684 51.7973 41.9585 51.2867L67.1937 44.8162C69.8907 44.1242 69.89 40.3317 67.1932 39.6398L54.2526 36.4046L50.6936 22.8167C49.9745 20.1557 45.8965 20.1514 45.1937 22.8167Z" fill="white"/>
        </g>
        </svg>
      </div>

      <div class="progressBarInner">
          <div class="progressBarInnerFiller"></div>
      </div>
    `;

    var progressBar = document.createElement('div');
    progressBar.classList.add("progressBar");
    document.body.prepend(progressBar);

    progressBar.innerHTML = template;

    await sleep(30);

    let progressBarWrapperLogo = document.getElementsByClassName("progressBarLogo")[0];
    progressBarWrapperLogo.classList.add("progressBarLogoReady");

    await sleep(500);

    this.filler = document.getElementsByClassName("progressBarInnerFiller")[0];

    this.timer = setInterval(this.sync.bind(this), 60);
  }


  async hide() {
    this.moveTo(100);
    await sleep(250);

    let progressBarWrapperLogo = document.getElementsByClassName("progressBarLogo")[0];
    progressBarWrapperLogo.classList.remove("progressBarWrapperLogoReady");

    var progressBar = document.getElementsByClassName("progressBar")[0];
    progressBar.style.opacity = 0;

    await sleep(450);
    progressBar.outerHTML = "";
    clearInterval(this.timer);
  }

  moveTo(perc) {
    this.state = perc;
  }


  sync() {
    this.filler.style.width = this.state + "%";
  }

  timer = null;
  filter = null;
  state = 0;
}
